/**
 * PlanDefinition schemas — rules engine rule packs.
 *
 * Sources: useRulesEngine.ts, PRD_RULES_ENGINE.md,
 * fhir-model/plan-definitions.ts
 */
import { z } from 'zod';

/** PlanDefinition.status values. */
export const planDefinitionStatusValues = ['draft', 'active', 'retired', 'unknown'] as const;

/**
 * Rule pack draft save — minimal validation before FHIR persist.
 */
export const rulePackDraftSchema = z.object({
  title: z.string().trim().min(1, 'Rule pack name is required'),
  status: z.enum(planDefinitionStatusValues).default('draft'),
  description: z.string().optional(),
  version: z.string().optional(),
});

export type RulePackDraftInput = z.infer<typeof rulePackDraftSchema>;
